import request from '@/utils/request'
const apiPrefix = `${process.env.VUE_APP_BASE_API}/Account/`

// 登录操作
export const getLogin = (params, config = {}) => {
    return request.post(apiPrefix + 'Login', params, config)
}
